import { useQuery } from 'react-query';
import { CategoriesTopicsTableAPI } from '../../../constants/API';
import axios from 'axios';
import { commonHeaders } from '../../../constants/HeadersAPI';
import {
  CategoriesAndTopicsForModal,
  categoryServiceItemInModal,
  categoryServiceType
} from '../../../types/Admin/CategoriesTopicsTypes';

export type ParentCategoryOption =
  | categoryServiceItemInModal
  | (categoryServiceType & { branchIds?: number[]; queueIds?: number[] });

export const useGetCategoriesTopicsForModal = (
  topLevel: ParentCategoryOption,
  setParentCategoryItems?: (items: ParentCategoryOption[]) => void
) => {
  const {
    data: categoriesAndTopics,
    isLoading: isLoadingAllCategoriesAndTopics,
    isSuccess: isAllCategoriesAndTopicsReceived
  } = useQuery(
    ['categoriesAndTopicsForModal'],
    () =>
      axios.get<CategoriesAndTopicsForModal>(
        CategoriesTopicsTableAPI.getCategoriesAndTopicsForModal,
        commonHeaders()
      ),
    {
      select: ({ data }) => data,
      onSuccess: (data: CategoriesAndTopicsForModal) => {
        if (!setParentCategoryItems) return;
        if (data?.categories) {
          setParentCategoryItems([topLevel, ...data.categories]);
        } else {
          setParentCategoryItems([topLevel]);
        }
      }
    }
  );
  return {
    categoriesAndTopics,
    isLoadingAllCategoriesAndTopics,
    isAllCategoriesAndTopicsReceived
  };
};
